module.exports = __webpack_public_path__ + "static/img/航空行程单.78bf3d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronic/航空行程单.png
// module id = W37d
// module chunks = 2